module.exports = __webpack_public_path__ + "static/gallery_yarra_6-e4eb1c929b99e1820a395671cdabdcd1.jpg";